'use client'

import { useState, useEffect } from 'react'

interface UseScrollOptions {
  threshold?: number
}

export function useHasScrolled({ threshold = 10 }: UseScrollOptions = {}) {
  const [hasScrolled, setHasScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > threshold)
    }

    window.addEventListener('scroll', handleScroll)

    // Check initial scroll position
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [threshold])

  return { hasScrolled }
}
